import React from 'react'

import CodeIcon from '@mui/icons-material/Code'

import { BookCardStyle } from '../styles'
import CodeNotebookModal from '../modals/CodeNotebookModal'
import ResourceCard from './ResourceCard'
import { openExternal } from '../../utils/safeUrl'

const CodeNotebookCard = (props) => {
    const openResource = () => {
        openExternal(props.link)
        return false;
    }

    return (
        <ResourceCard
            Icon={CodeIcon}
            cardStyle={BookCardStyle}
            modal={<CodeNotebookModal {...props} />}
            title={props.title}
            description={props.description}
            date={props.pub_date}
            dateLabel='Updated:'
            content_tags={props.content_tags}
            medical_specialty_tags={props.medical_specialty_tags}
            is_seminal_work={props.is_seminal_work || props.seminal_work}
            onOpen={openResource}
            buttonText='View Notebook'
        />
    )
}

export default CodeNotebookCard
